













































































































import Component from "vue-class-component";
import StandardList from "front-component/components/List.vue";
import {Prop, Watch} from "vue-property-decorator";
import {Getter} from "vuex-class";
import OwnerRepository from "@/repositories/OwnerRepository";
import moment from "moment";
import _ from "lodash";
import PlaceLinkingRepository from "@/repositories/PlaceLinkingRepository";
import Http from "front-component/Http";

const components = {};
interface PlaceLinking {
    uuid: string;
    geomarket: boolean;
    selected: boolean;
    owner: {
        uuid: string;
    };
    place: {
        uuid: string;
        cospiritCode: string;
        name: string;
        postalCodeCity: string;
    };
    hidden: boolean;
}

interface MiniOwner {
    uuid: string;
    fullName: string;
    cospiritCode: string;
    competitorStatus: string;
}
@Component({ components })
export default class List extends StandardList {
    @Getter("getCurrentOwnerUuid") public currentOwnerUuid!: string;
    protected route: string = "get_owner";
    protected fields: string[] = [];
    public validationDeadline: string = moment("2026-04-13 23:59:59").format("YYYY-MM-DD HH:mm:ss");
    public dateNow: string = moment().format("YYYY-MM-DD HH:mm:ss");
    public modalCompetitorVisible: boolean = false;
    private loadingCompetitors: boolean = false;
    public competitorsSelected: PlaceLinking[] = [];
    public previousCompetitorsSelected: PlaceLinking[] = [];
    public competitors: PlaceLinking[] = [];
    public currentOwner: MiniOwner | null = null;
    public keywordSearch: string = "";

    @Prop( { default: 50}) public limitPerPage !: number;

    public created(): void {
        this.fields = [
            "uuid",
            "fullName",
            "cospiritCode",
            "competitorStatus"
        ];
    }

    public canEdit(): boolean {
        return this.dateNow < this.validationDeadline;
    }
    protected link(): string {
        return OwnerRepository.getSearchUrl();
    }

    @Watch("limitPerPage") public refresh() {
        this.page = 1;
        this.hasNextPage = true;
        this.elements = [];
        this.loadUsingApi();
    }

    public selectCompetitor(ownerUuid: string): void {
        this.competitors = [];
        const owner = _.find(this.elements, (line: PlaceLinking) => {
            return line.uuid === ownerUuid;
        });

        if (!owner) {
            this.$message({
                duration: 10000,
                message: "error",
                type: "error"
            });
        } else {
            this.currentOwner = owner as unknown as MiniOwner;
            this.modalCompetitorVisible = true;
            this.loadingCompetitors = true;
            PlaceLinkingRepository.get({ filters: { ownerUuid } }).then((data: any[]) => {
                this.loadingCompetitors = false;
                this.competitors = data;
                this.competitorsSelected = _.filter(data, (line: PlaceLinking) => {
                    return line.selected === true;
                });
                if (0 === this.competitorsSelected.length) {
                    this.competitorsSelected = _.filter(data, (line: PlaceLinking) => {
                        return line.geomarket === true;
                    });
                }
                this.previousCompetitorsSelected = _.cloneDeep(this.competitorsSelected);
            });
        }
    }

    private closed(): void {
        this.modalCompetitorVisible = false;
    }

    @Watch("keywordSearch") private updateCompetitorList(): void {
        this.competitors.map((line) => {
            return line.hidden = false;
        });

        if (this.keywordSearch !== "" && this.keywordSearch.length > 3) {
            this.competitors.map((item) => {
                if (
                    item.place.name.toLowerCase().indexOf(this.keywordSearch.toLowerCase()) === -1 &&
                    item.place.cospiritCode.toLowerCase().indexOf(this.keywordSearch.toLowerCase())  === -1 &&
                    item.place.postalCodeCity.toLowerCase().indexOf(this.keywordSearch.toLowerCase())  === -1
                ) {
                    item.hidden = true;
                }
            });
        }
    }

    private validCompetitors(done: () => void): void {
        this.$confirm(_.invoke(this.$options.filters, "trans", "validChoices"))
            .then(() => {
                this.loadingCompetitors = true;
                const selectedUuids: string[] = [];
                _.forEach(this.competitorsSelected, (line) => {
                    selectedUuids.push(line.uuid);
                });

                const body = { selectedUuids };

                Http.callDirect(
                    "/competitor_select/" + this.currentOwner?.uuid,
                    body,
                    (data: any) => {
                        this.loadingCompetitors = false;
                        this.$message({
                            duration: 10000,
                            message: _.invoke(this.$options.filters, "trans", "competitorUpdated"),
                            type: "success"
                        });
                        this.modalCompetitorVisible = false;
                        this.refreshList();
                    },
                    () => {
                        this.$message({
                            duration: 10000,
                            message: _.invoke(this.$options.filters, "trans", "error"),
                            type: "error"
                        });
                        this.loadingCompetitors = false;
                    }
                );

                done();
                return;
            })
            .catch(() => {
                return;
            })
        ;
    }

    private isSelected(uuid: string): boolean {
        return !!_.find(this.competitorsSelected, (line) => {
            return line.uuid === uuid;
        });
    }

    private updateCompetitor(uuid: string, add: boolean): void {
        const placeLinking = _.find(this.competitors, (line) => {
            return line.uuid === uuid;
        });

        if (add && placeLinking) {
            this.competitorsSelected.push(placeLinking);
        }

        if (!add) {
            this.competitorsSelected = _.remove(this.competitorsSelected, (line) => {
                return line.uuid !== uuid;
            });
        }
    }
}
